export function scrollIntoView(target?: HTMLElement | string | null) {
  const element =
    typeof target === 'string' ? document.querySelector(target) : target;

  if (element && 'scrollIntoView' in element) {
    element.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
